module.exports = __webpack_public_path__ + "static/social-banner-c04615c93c0a3d11a840cc49babe5b87.jpg";